import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./pages/Header";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Studio from "./pages/Studio";
import Contact from "./pages/Contact";
import Footer from "./pages/Footer";
import Feedback from "./pages/Feedback";

function App() {
  return (
    <Router>
      <div className="w-full min-h-screen bg-[#f9f4ee] flex flex-col">
        <Header />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/feedbacks" element={<Feedback />} />
          </Routes>
        </div>
        <Footer className="mt-auto" />
      </div>
    </Router>
  );
}

export default App;
